import type { Bundle, BundlePayload, MultiUpdateBundlePayload } from './bundles-types'
import { api } from '@/api/api'

export const bundlesService = {
  add: async (payload: BundlePayload) => {
    const { data } = await api.post<Bundle>('/bundles/', payload)

    return data
  },
  multiUpdate: async (payload: MultiUpdateBundlePayload) => {
    const { data } = await api.post<Bundle[]>('/bundles/multiupdate/', payload)
    return data
  },
  recalculate: async (originItemId: string, params: { amount_of_bundles: number }) => {
    const { data } = await api.post<Bundle>(`bundles/${originItemId}/recalculate/`, undefined, {
      params
    })
    return data
  },
  update: async (id: number, payload: Partial<BundlePayload>) => {
    const { data } = await api.patch<Bundle>(`/bundles/${id}/`, payload)

    return data
  },
  delete: async (id: number) => {
    const { data } = await api.delete<Bundle>(`/bundles/${id}/`)
    return data
  }
}
